<!-- 弹框分页 -->
<template>
  <div class="xm-pagination-d" v-if="total > 0">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPages"
      :page-size="currentPagesize"
      layout="prev, pager, next, jumper"
      :total="currentTotal"
      class="pagination-style"
      :pager-count="5"
      :hide-on-single-page="isShow"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'pagToolsDialog',
  data() {
    return {
      currentPages: this.pages,
      currentPagesize: this.pagesize,
      currentTotal: this.total,
    };
  },
  props: {
    pages: {
      type: Number,
      default: 1,
    },
    pagesize: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      default: 0,
    },
    // 当数据只有一页时是否隐藏分页器
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    total(n) {
      this.currentTotal = n;
      console.log(123);
    },
    pages(n, o) {
      if (n) {
        this.currentPages = n;
        this.handleCurrentChange(this.currentPages);
      }
    },
    pagesize(n) {
      this.currentPagesize = n;
    },
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.$emit('go-pages', val);
    },
  },
};
</script>
<style lang="scss" scoped>
.xm-pagination-d {
  text-align: center;
  ::v-deep .el-pagination__editor.el-input .el-input__inner {
    height: 32px;
    border-radius: 0;
  }
}
::v-deep .el-pager li.active + li {
  color: #606266;
}
::v-deep .el-pager li {
  font-size: 14px;
  font-weight: 400;
}
</style>
